export const UPDATE_MEDIA_QUERY = 'mediaQuery/UPDATE_MEDIA_QUERY';

export const SET_MEDIA_QUERY = 'mediaQuery/SET_MEDIA_QUERY';
